import storageService, { Locals } from '../../utils/storageService';
import useShopifyCart from '../shopify/useShopifyCart';
import { CartLineInput, CartLinesAddResp } from '../../models/ShopifyCartShema';
import { isNullOrUndefined } from '../../utils/utils';
import { InvoiceDetailsData } from '../../models/Invoice';
import { CartAddError, CartLineItemAdd } from '../../models/Cart';

const useCart = () => {
    const shopifyCart = useShopifyCart();

    const createCart = () => {
        return shopifyCart
            .createNewShopifyCart({
                buyerIdentity: {
                    customerAccessToken: storageService.getItem(
                        Locals.SHOPIFY_ACCESS_TOKEN
                    ),
                },
                attributes: [
                    {
                        key: 'payment_method',
                        value: 'UTANVET',
                    },
                ],
            })
            .then((cartResp) => {
                storageService.setItem(
                    Locals.CART_TOKEN,
                    cartResp.cartCreate.cart.id
                );
                return cartResp;
            });
    };

    const createCartLineItem = (
        product: InvoiceDetailsData
    ): CartLineItemAdd => {
        return {
            merchandiseId:
                'gid://shopify/ProductVariant/' + product.shopify_variant_id,
            quantity: product.quantity == 0 ? 1 : product.quantity,
        };
    };

    const fetchInvoiceProductsForCart = (
        productList: InvoiceDetailsData[]
    ): CartLineItemAdd[] => {
        return productList
            .filter(
                (elem) =>
                    elem.lineType == 'Item' &&
                    !isNullOrUndefined(elem.shopify_variant_id)
            )
            .map((elem) => {
                return createCartLineItem(elem);
            });
    };

    const addInvoiceProductsToCart = (
        productList: CartLineInput[]
    ): Promise<CartLinesAddResp> => {
        return shopifyCart.addNewProductToShopifyCart(productList);
    };

    const checkForShopifyProducts = (
        productList: InvoiceDetailsData[]
    ): Promise<CartLineItemAdd[]> => {
        return new Promise((resolve, reject) => {
            const products = fetchInvoiceProductsForCart(productList);
            if (!isNullOrUndefined(products) && products.length > 0) {
                resolve(products);
            } else {
                reject(new Error('Nincs shopify-os termék a listában'));
            }
        });
    };

    const getAvailableProducts = (
        errors: CartAddError[],
        productList: InvoiceDetailsData[]
    ): CartLineItemAdd[] => {
        return productList
            .filter((elem) => {
                return !errors.find((error) => {
                    return error.message.includes(
                        elem.shopify_variant_id.toString()
                    );
                });
            })
            .map((elem) => {
                return createCartLineItem(elem);
            });
    };

    return {
        createCart,
        addInvoiceProductsToCart,
        checkForShopifyProducts,
        getAvailableProducts,
    };
};

export default useCart;
